<template>
  <d-modal
    size="lg"
    @close="handleClose">
    <d-modal-header>
      <d-modal-title>
        {{ $t('shipments.popups.addPOD') }}
      </d-modal-title>
    </d-modal-header>

    <d-modal-body>
      <d-form>
        <validation-observer
          ref="pod-add-form"
          tag="form">
          <div class="form-group">
            <label>
              {{ $t('shipments.popups.podFile') }}:
            </label>

            <validation-provider
              rules="required"
              name="file"
              v-slot="{ errors }">
              <file-input
                :onChange="setNewFile"
                id="podInputFile" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>

          <div class="form-group">
            <label>
              {{ $t('shipments.popups.trackingNumber') }}:
            </label>

            <validation-provider
              rules="required"
              name="tracking_number"
              v-slot="{ errors }">
              <d-input
                :state="errors.length ? 'invalid' : null"
                v-model="trackingNumber" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>

          <div class="form-group">
            <label for="shipper">
              {{ $t('ui.shipper') }}:
            </label>

            <validation-provider
              rules="required"
              name="shipper_id"
              v-slot="{ errors }">
              <div :class="{ 'form-control': true, 'is-select': true, 'is-invalid': errors.length }">
                <v-select
                  :options="shipperOptions"
                  v-model="shipperID"
                  :searchable="false"
                  :clearable="true"
                  :reduce="shipper => shipper.value"
                  :placeholder="$t('shippers.chooseShipper')"
                  label="text">
                  <template slot="no-options">
                    {{ $t('shippers.noShippersAvailable') }}&hellip;
                  </template>
                </v-select>
              </div>

              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>
        </validation-observer>
      </d-form>
    </d-modal-body>

    <d-modal-footer>
      <d-button
        class="ml-0"
        theme="danger"
        @click.prevent="cancel"
        :disabled="saveInProgress">
        {{ $t('ui.cancel') }}
      </d-button>

      <d-button
        class="ml-auto"
        theme="success"
        @click.prevent="validateForm"
        :disabled="saveInProgress">
        {{ $t('shipments.popups.savePOD') }}
      </d-button>
    </d-modal-footer>
  </d-modal>
</template>

<script>
import FormUtils from '../../utils/FormUtils.js';
import jsonToFormData from 'json-form-data';
import Vue from 'vue';

export default {
  name: 'shipment-add-pod-popup',
  props: [
    'orderID'
  ],
  computed: {
    shipperOptions () {
      return this.shippers.map(shipper => ({
        value: shipper.code,
        text: shipper.name
      }));
    }
  },
  data () {
    return {
      podFile: null,
      trackingNumber: null,
      shipperID: null,
      // other
      shippers: [],
      // UI flags
      saveInProgress: false
    };
  },
  mounted () {
    this.$bus.$on('order-receive-shipment-data', this.setOrderData);
    this.$bus.$emit('order-send-request-shipment-data');
  },
  methods: {
    handleClose () {
      this.$bus.$emit('add-pod-popup-close');
    },
    validateForm () {
      FormUtils.validate(this.$refs['pod-add-form'], this.save);
    },
    setNewFile (event) {
      this.podFile = event.target.files[0];
    },
    save () {
      this.saveInProgress = true;

      let podData = {
        tracking_number: this.trackingNumber,
        order_id: this.orderID,
        shipper: this.shipperID,
        pod_file: this.podFile
      };

      this.$http.request({
        method: 'POST',
        url: '/shipments/store-pod',
        headers: { 'Content-Type': undefined },
        transformRequest (data) {
          let dataToSend = jsonToFormData(data);
          return dataToSend;
        },
        data: podData
      }).then((response) => {
        if (response.data.success) {
          Vue.swal({
            title: this.$t('shipments.popups.podSaved'),
            html: this.$t('shipments.popups.podSavedDesc'),
            type: 'success',
            confirmButtonText: this.$t('ui.ok'),
            buttonsStyling: true,
            timer: 2000
          });

          this.$bus.$emit('shipments-reload');
        }

        this.handleClose();
        this.saveInProgress = false;
      }).catch(error => {
        console.log(error);
        Vue.swal({
          title: this.$t('shipments.popups.podSaveError'),
          html: this.$t('ui.tryAgain'),
          type: 'warning',
          confirmButtonText: this.$t('ui.ok'),
          buttonsStyling: true
        });
        this.saveInProgress = false;
      });
    },
    setOrderData (dataToSet) {
      Vue.set(this, 'trackingNumber', dataToSet.trackingNumber);
      Vue.set(this, 'shipperID', dataToSet.shipperID);
      Vue.set(this, 'shippers', dataToSet.shippers);
    },
    cancel () {
      this.handleClose();
    }
  },
  beforeDestroy () {
    this.$bus.$off('order-receive-shipment-data', this.setOrderData);
  }
}
</script>
